import palette from './palette.mjs';

const {
  primary: { text6, light },
} = palette;

export default {
  MuiRadio: {
    root: {
      borderRadius: 8,
      padding: 8,
      '& .MuiTouchRipple-child': {
        borderRadius: 8,
      },
      '&.small': {
        '& .MuiIconButton-label > svg': { height: 16, width: 16 },
      },
      color: text6,
      '&.MuiRadio-colorPrimary.Mui-checked:hover': {
        backgroundColor: 'rgba(99, 239, 255, 0.04)', // NOTE: primary color
      },

      '&.MuiRadio-colorPrimary.Mui-checked:hover .MuiIconButton-label path:nth-of-type(1)': {
        stroke: light,
      },
      '&.MuiRadio-colorPrimary.Mui-checked:hover .MuiIconButton-label path:nth-of-type(2)': {
        fill: light,
      },
    },

    colorPrimary: {
      '&.Mui-disabled > .MuiIconButton-label': { opacity: 0.4 },
      '&.Mui-checked.Mui-disabled  > .MuiIconButton-label': { opacity: 0.4 },
    },
  },
};
